module.exports = __webpack_public_path__ + "img/binner-3.5ca787c2.png";